import Box from "@mui/material/Box";
import { useContext, useEffect, useRef, useState } from "react";
import { Loading } from "react-admin";
import { useParams } from "react-router";
import { BiCopy, BiShareAlt, BiTrash } from "react-icons/bi";
import apiCalls from "../../Configs/config";
import { APIContext } from "../../store/APIStore";
import FdTypography from "../../components/UIComponents/Typography/FdTypography";
import FdButton from "../../components/UIComponents/Button/FdButton";
import NotificationMessage, {
  notificationType,
} from "../../components/NotificationMessage/NotificationMessage";
import { analytics as classes } from "./styles";
import FdTextField from "../../components/UIComponents/TextField/FdTextfield";
import { InputAdornment } from "@mui/material";
import Menu from "@mui/material/Menu";

const DashboardShareMenuDialog = ({
  anchorEl,
  closePublicSharingMenuDialog,
  publicSharingUrl,
  setPublicSharingUrl,
}: {
  anchorEl: null | HTMLElement;
  closePublicSharingMenuDialog: any;
  setPublicSharingUrl: any;
  publicSharingUrl: string;
}) => {
  const api = useContext(APIContext);
  const notificationRef = useRef<any>();
  const { eventId } = useParams() as { eventId: string };

  const revokePublicSharingToken = async () => {
    try {
      await api.analyticsSettingsService.revokePublicSharingToken(eventId);
      setPublicSharingUrl("" as string);
      closePublicSharingMenuDialog();
    } catch (error: any) {
      notificationRef.current?.show(
        error?.response?.data?.message,
        notificationType.Error
      );
    }
  };

  return (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={closePublicSharingMenuDialog}
    >
      {/* <Box>
      </Box> */}
      <Box sx={{ padding: "18px" }}>
        <FdTypography
          color="textSecondary"
          variant="body1"
          component="h3"
          label="Public link"
          sx={{ fontWeight: "bold" }}
        />
        <FdTypography
          variant="body2"
          component="h3"
          color="textSecondary"
          label="Anyone can view this if you give them the link."
        />
        <FdTextField
          required
          name="url"
          id="url"
          value={publicSharingUrl ? publicSharingUrl : "Loading..."}
          fullWidth
          sx={{
            "& .MuiInputBase-input": {
              textOverflow: "ellipsis",
              paddingRight: "36px",
            },
          }}
          InputProps={{
            sx: classes.textFieldWithAdornment,
            readOnly: true,
            fullWidth: true,
            endAdornment: (
              <InputAdornment position="end" sx={classes.inputIcon}>
                <BiCopy
                  onClick={() =>
                    navigator.clipboard.writeText(publicSharingUrl)
                  }
                />
              </InputAdornment>
            ),
          }}
        />
        <FdButton
          variant="text"
          color="primary"
          size="small"
          onClick={revokePublicSharingToken}
          ButtonName="Revoke Public Url"
        />
      </Box>
    </Menu>
  );
};
export default DashboardShareMenuDialog;
